"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const THREE = __importStar(require("three"));
const gsap_1 = require("gsap");
const LampShadow_1 = __importDefault(require("./LampShadow"));
const Util_1 = __importDefault(require("../../Util"));
const vs = `
  varying vec2 v_uv;
  void main() {
    v_uv = uv;
    gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
  }
`;
const fs = `
  precision mediump float;
  varying vec2 v_uv;
  uniform float u_progress;
  uniform float u_radius;
  uniform vec3 fogColor;
  uniform float fogNear;
  uniform float fogFar;

  vec4 getColor (vec2 st) {
    float radius = u_radius;
    vec4 color = vec4(1.0, 1.0, 1.0, 1.0);
    float dist = distance(st, vec2(0.0));
    if (dist > radius) {
      float sub = dist - radius;
      color.a = sub < 0.05 ? smoothstep(1.0, 0.0, sub/0.05): 0.0; 
    }
    return color;
  }

  void main() {
    vec2 st = 2.0 * v_uv - 1.0;
    gl_FragColor = getColor(st);
    #ifdef USE_FOG
      #ifdef USE_LOGDEPTHBUF_EXT
        float depth = gl_FragDepthEXT / gl_FragCoord.w;
      #else
        float depth = gl_FragCoord.z / gl_FragCoord.w;
      #endif
      float fogFactor = smoothstep( fogNear, fogFar, depth );
      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      //gl_FragColor = vec4(gl_FragCoord.z);
    #endif
  }
`;
class Lamp extends THREE.Object3D {
    constructor(width = 1, height = 1, minY = 0, texture) {
        super();
        this.uniforms = {
            u_progress: { value: 0.0 },
            u_radius: { value: 0.05 },
            fogColor: { type: 'c', value: new THREE.Color() },
            fogNear: { type: 'f', value: 0.0 },
            fogFar: { type: 'f', value: 0.0 },
        };
        this.texture = texture;
        this.time = 0;
        this.timeGap = Util_1.default.random(0.01, 0.04);
        this.width = width;
        this.height = height;
        this.minY = minY;
        this.shape = null;
        this.bulb = null;
        this.line = null;
        this.shadow = null;
        this.visible = false;
        this.isAnimate = false;
    }
    draw() {
        this._createShape();
    }
    animate() {
        this.visible = true;
        this.isAnimate = true;
        const size = Util_1.default.map(this.minY, 0, 10, 1, 0.1);
        this.bulb && gsap_1.gsap.to(this.bulb.scale, { duration: 1, x: 1, y: 1 });
        this.shadow &&
            gsap_1.gsap.to(this.shadow.scale, { duration: 1, x: size, y: size, z: 1 });
    }
    update(time, cameraPos) {
        if (!this.isAnimate)
            return;
        this.time += this.timeGap;
        this.uniforms.u_radius.value = Math.sin(this.time) * 0.1 + 0.2;
        this.bulb && this.bulb.lookAt(cameraPos);
        if (!this.shadow)
            return;
        this.shadow.update();
        this.shadow.setRadius(this.uniforms.u_radius.value);
    }
    setFog(fog) {
        this.uniforms.fogColor = { type: 'c', value: fog.color };
        this.uniforms.fogNear = { type: 'f', value: fog.near };
        this.uniforms.fogFar = { type: 'f', value: fog.far };
        this.shadow && this.shadow.setFog(fog);
    }
    _createShape() {
        const bulbY = this.minY + 1 + 1;
        const bulbRadius = 0.2;
        const bulbGeo = new THREE.PlaneBufferGeometry(this.width, this.height, 1, 1);
        const bulbMat = new THREE.ShaderMaterial({
            vertexShader: vs,
            fragmentShader: fs,
            uniforms: this.uniforms,
            transparent: true,
            side: THREE.DoubleSide,
            fog: true,
        });
        this.bulb = new THREE.Mesh(bulbGeo, bulbMat);
        this.bulb.position.set(0, bulbY + bulbRadius, 0);
        this.bulb.scale.set(0.1, 0.1, 0);
        this.add(this.bulb);
        this._createLampShadow(bulbY);
    }
    _createBulb() {
    }
    _createLine(bulbRadius, bulbY) {
        const lineWidth = 0.003;
        const lineHeight = 4;
        const lineGeo = new THREE.BoxBufferGeometry(lineWidth, lineHeight, lineWidth);
        const lineMat = new THREE.MeshBasicMaterial({ color: 0xefefef });
        this.line = new THREE.Mesh(lineGeo, lineMat);
        this.line.position.set(0, lineHeight / 2 + bulbRadius * 2 + bulbY, 0);
        this.add(this.line);
    }
    _createLampShadow(bulbY) {
        this.shadow = new LampShadow_1.default(Math.max(2 - bulbY + 0.3, 1), Math.max(2 - bulbY + 0.3, 1), this.texture);
        this.shadow.scale.set(0.1, 0.1, 0.1);
        this.add(this.shadow);
    }
}
exports.default = Lamp;
